import {createSlice, isAnyOf} from '@reduxjs/toolkit';

import {revertLocationParamsConvertion} from 'app/store/sweet-api/utils';

import {extendedAPI} from './api';

import type {NotificationsLocationParamsType} from './types';
import type {DefaultRootState} from 'react-redux';

const initialState = {filters: {} as NotificationsLocationParamsType};

const matchFilterChanged = isAnyOf(
  extendedAPI.endpoints.notifications.matchPending,
  extendedAPI.endpoints.notifications.matchRejected
);

export const notiflySlice = createSlice({
  name: 'notifly',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(matchFilterChanged, (state, action) => ({
      filters: revertLocationParamsConvertion(action.meta.arg.originalArgs),
    }));
  },
});

export const selectNotiflyFilters = (state: DefaultRootState) =>
  state.notifly.filters;
